import React from 'react';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import { useProgressContext } from '@/contexts/useProgressContext';
import { useAuthState } from '@/plugins/Auth';

import preOrderAPI from '@/api/preOrder';

import Header from '@/containers/Layout/Header';
import { DELIVERY_METHOD } from '@/helper';
import PurchasedPreOrderCard from './PurchasedPreOrderCard';

const separateOrders = (orders) => {
  const now = new Date().getTime();
  const result = {
    orderDic: {},
    historyOrderDic: {},
  };

  Object.keys(orders)
    .forEach((orderId) => {
      const order = orders[orderId];
      const {
        batch = '',
        batches = {},
        delivery: {
          date = '',
        } = {},
        preOrderFridgeId = '',
      } = order;

      if (preOrderFridgeId === DELIVERY_METHOD.DELIVERY) {
        const orderTime = +moment(date);
        if (orderTime < now) {
          result.historyOrderDic[orderId] = {
            ...order,
            orderTime,
          };
        } else {
          result.orderDic[orderId] = {
            ...order,
            orderTime,
          };
        }
      } else {
        const redeemEndTime = batches?.[batch]?.redeemEndTime || order.redeemEndTime || 0;
        const redeemStartTime = batches?.[batch]?.redeemStartTime || order.redeemStartTime || 0;
        if (redeemEndTime < now) {
          result.historyOrderDic[orderId] = {
            ...order,
            orderTime: redeemStartTime,
          };
        } else {
          result.orderDic[orderId] = {
            ...order,
            orderTime: redeemStartTime,
          };
        }
      }
    });
  return result;
};

const PurchasedOrderList = () => {
  const { token } = useAuthState();
  const {
    start: startProgress,
    end: endProgress,
  } = useProgressContext();

  const [personalOrderDic, setPersonalOrderDic] = React.useState({});
  const [personalHistoryOrderDic, setPersonalHistoryOrderDic] = React.useState({});

  React.useEffect(() => {
    startProgress();
    preOrderAPI.getPersonalPreOrderList({
      query: {
        token,
      },
    }).then(({ status, customerPreOrders: customerPreOrderData }) => {
      if (status !== 'OK') return;
      const {
        orderDic,
        historyOrderDic,
      } = separateOrders(customerPreOrderData);
      setPersonalOrderDic(orderDic);
      setPersonalHistoryOrderDic(historyOrderDic);
    }).finally(() => {
      endProgress();
    });
  }, []); // eslint-disable-line

  return (
    <>
      <Header />
      <Box mx={1}>
        <Box py={0.5}>
          <Divider />
        </Box>
        <Box
          fontSize="subtitle1.fontSize"
          fontWeight="fontWeightBold"
          textAlign="center"
        >
          參與中的預購
        </Box>
        <Box pt={0.5}>
          <Divider />
        </Box>
        <Box>
          <Grid container>
            {
              Object.keys(personalOrderDic)
                .sort((k1, k2) => {
                  const t1 = personalOrderDic[k1]?.orderTime || 0;
                  const t2 = personalOrderDic[k2]?.orderTime || 0;
                  return t1 - t2;
                })
                .map((orderId) => {
                  const order = personalOrderDic[orderId];
                  return (
                    <Grid item key={orderId} xs={12}>
                      <PurchasedPreOrderCard
                        data={order}
                      />
                    </Grid>
                  );
                })
            }
          </Grid>
        </Box>
        <Box pt={0.5}>
          <Divider />
        </Box>
        <Box
          fontSize="subtitle1.fontSize"
          fontWeight="fontWeightBold"
          textAlign="center"
        >
          預購歷史紀錄
        </Box>
        <Box pt={0.5}>
          <Divider />
        </Box>
        <Box>
          <Grid container>
            {
              Object.keys(personalHistoryOrderDic)
                .sort((k1, k2) => {
                  const t1 = personalHistoryOrderDic[k1]?.orderTime || 0;
                  const t2 = personalHistoryOrderDic[k2]?.orderTime || 0;
                  return t2 - t1;
                })
                .map((orderId) => {
                  const order = personalHistoryOrderDic[orderId];
                  return (
                    <Grid item key={orderId} xs={12}>
                      <PurchasedPreOrderCard
                        data={order}
                      />
                    </Grid>
                  );
                })
            }
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default PurchasedOrderList;
